(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeHabitsComponent', psychIntakeHabitsComponent);

    psychIntakeHabitsComponent.$inject = [];

    function psychIntakeHabitsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeHabitsController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/habits.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeHabitsController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeHabitsController($scope, $stateParams, $element) {
        var vm = this;

        function init() {}

        init();
    }
})();
